export default {
  loading: false,
  mgmt_quotations: [],
  mgmt_quotation: {},
  totalCount: 0,
};
